// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y5PU","delete":"styles_delete__3Uh3V","update":"styles_update__8QVR2","add":"styles_add__1utyn"};